import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutSessionComponent } from './layout-session/layout-session.component';
import { RouterModule } from '@angular/router';
import { LayoutBlankComponent } from './layout-blank/layout-blank.component';
import { LayoutRestrictAreaComponent } from './layout-restrict-area/layout-restrict-area.component';
import { LayoutRestrictAreaHeaderComponent } from './layout-restrict-area/header/layout-restrict-area-header.component';
import { LayoutRestrictAreaSidebarComponent } from './layout-restrict-area/sidebar/layout-restrict-area-sidebar.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedPipesModule } from '@app-shared/pipes/shared-pipes.module';
import { SharedDirectivesModule } from '@app-shared/directives/shared-directives.module';
import { FilterModule } from '@app-shared/filter/filter.module';
import { LayoutRestrictHeaderComponent } from './layout-restrict-header/layout-restrict-header.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
	declarations: [
		LayoutSessionComponent,
		LayoutBlankComponent,
		LayoutRestrictAreaComponent,
		LayoutRestrictAreaHeaderComponent,
		LayoutRestrictAreaSidebarComponent,
    LayoutRestrictHeaderComponent
	],
	imports: [
    CommonModule,
    NgbModule,
    RouterModule,
    FilterModule,
    SharedPipesModule,
    SharedDirectivesModule,
    MatButtonModule
  ],
	exports: [
    LayoutSessionComponent,
    LayoutRestrictAreaComponent,
    LayoutBlankComponent,
    LayoutRestrictHeaderComponent
  ]
})
export class LayoutsModule {}
